import { render, staticRenderFns } from "./IndividualsHeader.vue?vue&type=template&id=63da5e02&scoped=true"
import script from "./IndividualsHeader.vue?vue&type=script&lang=js"
export * from "./IndividualsHeader.vue?vue&type=script&lang=js"
import style0 from "./IndividualsHeader.vue?vue&type=style&index=0&id=63da5e02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63da5e02",
  null
  
)

export default component.exports